export function setupAccordions() {
  const accordions = document.querySelectorAll(".as-accordion");
  if (accordions > 0) {
    accordions.forEach((target) => {
      target.addEventListener("click", () => {
        accordions.forEach((accordion) => {
          accordion !== target && accordion.removeAttribute("open");
        });
      });
    });

    const expandAllButton = document.createElement('button');
    const collapseAllButton = document.createElement('button');

    expandAllButton.classList.add(...['as-button', 'as-button--ghost', 'as-accordions-expand-all']);
    expandAllButton.innerText = "Expand All";
    expandAllButton.addEventListener('click', () => {
      accordions.forEach((accordion) => {
        accordion.setAttribute("open", "");
      });
    });

    collapseAllButton.classList.add(...['as-button', 'as-button--ghost', 'as-accordions-collapse-all']);
    collapseAllButton.innerText = "Collapse All";
    collapseAllButton.addEventListener('click', () => {
      accordions.forEach((accordion) => {
        accordion.removeAttribute("open");
      });
    });

    const accordionsToggleButtons = document.createElement('div');
    accordionsToggleButtons.classList.add(...['as-container', 'as-flex-container', 'as-accordions-toggle']);

    accordionsToggleButtons.innerHTML = `${expandAllButton.outerHTML} | ${collapseAllButton.outerHTML}`

    const accordionsContainer = document.querySelector('.as-accordion').parentElement;
    accordionsContainer.insertAdjacentElement('beforebegin', accordionsToggleButtons);
  }
}